<template>
  <div class="login-bg" aria-hidden="true">
    <div class="login-bg__layer login-bg__glow" />
    <div class="login-bg__layer login-bg__particles">
      <span
        v-for="n in 10"
        :key="n"
        class="login-bg__particle"
      />
    </div>
    <div class="login-bg__layer login-bg__grid-wrap">
      <div class="login-bg__grid" />
    </div>
    <div class="login-bg__blob login-bg__blob--1" />
    <div class="login-bg__blob login-bg__blob--2" />
    <div class="login-bg__blob login-bg__blob--3" />
  </div>
</template>

<script setup>
defineOptions({ name: 'LoginBackground' })
</script>
